export const ROOT_PORTALS = 'react-root-portals';
